import { RouteObject, createBrowserRouter } from 'react-router-dom';
import { AuthGuard, GuestGuard, PermissionGuard, ReceptionLockGuard } from './guards';
import { AppRouteLayout, FullScreenLayout, RootLayout } from './layouts';
import { appRouteModules, fullScreenRouteModules, guestRouteModules, checkInRoutes } from './routes';

// 비인증 라우트 설정
export const nonAuthedRoutes: RouteObject = {
	element: <GuestGuard />,
	children: [
		{
			element: <RootLayout />,
			children: guestRouteModules
		}
	]
};

// 인증 라우트 설정
export const authedRoutes: RouteObject = {
	element: <AuthGuard />,
	children: [
		{
			element: <PermissionGuard />,
			children: [
				{
					element: <RootLayout />,
					children: [
						{
							// 리셉션 모드 활성 중에는 스캔 콘솔 밖(일반 관리자 화면) 접근 차단
							element: <ReceptionLockGuard />,
							children: [
								// 헤더 포함 레이아웃
								{
									element: <AppRouteLayout />,
									children: appRouteModules
								},
								// 헤더 비포함 레이아웃 (풀스크린)
								{
									element: <FullScreenLayout />,
									children: fullScreenRouteModules
								}
							]
						},
						// 현장 체크인 전용 (헤더 없는 전용 레이아웃, ReceptionGuard 내장)
						checkInRoutes
					]
				}
			]
		}
	]
};

// 전체 라우트 구성
const routes: RouteObject[] = [nonAuthedRoutes, authedRoutes];

export const router = createBrowserRouter(routes);
